import type { LDClient } from 'launchdarkly-js-client-sdk'
import Observability from '@launchdarkly/observability'
import SessionReplay from '@launchdarkly/session-replay'
import { initialize } from 'launchdarkly-js-client-sdk'

let ldClient: LDClient | null = null

function getAnonymousKey() {
  const KEY = 'ld-anon-key'
  try {
    let key = localStorage.getItem(KEY)
    if (!key) {
      key = (crypto.randomUUID?.() ?? `${Date.now()}-${Math.random()}`)
      localStorage.setItem(KEY, key)
    }
    return key
  }
  catch {
  // In case localStorage is unavailable (e.g. in private browsing mode), fall back to a random key that won't persist across sessions
    return `${Date.now()}-${Math.random()}`
  }
}
export function initLD(): void {
  if (ldClient) {
    return // Already initialized
  }
  const shouldInitializeLaunchDarkly = window.injectedEnv.FRONTEND_LAUNCHDARKLY_ENABLED === 'true'
    && !(window as any).Cypress
  if (!shouldInitializeLaunchDarkly) {
    return
  }
  ldClient = initialize(window.injectedEnv.FRONTEND_LAUNCHDARKLY_CLIENTSIDEID, { kind: 'user', key: getAnonymousKey(), anonymous: true }, {
    plugins: [
      new Observability({
        tracingOrigins: ['pri.highlight.io'],
        networkRecording: {
          enabled: true,
          recordHeadersAndBody: false,
        },
        environment: window.injectedEnv.FRONTEND_NAMESPACE,
        version: window.injectedEnv.FRONTEND_APP_VERSION,
      }),
      new SessionReplay({
        privacySetting: 'default',
      }),
    ],
  })
}
export function identifyUser(username: string, attributes?: { [key: string]: string }) {
  if (!ldClient)
    return
  identifyJourneyInfo(username, '', false, '', '', attributes)
}

export function identifyJourneyInfo(userName: string, pageName: string, isEndOfJourney: boolean, quoteID?: string, policyNumber?: string, attributes?: { [key: string]: string }) {
  if (!ldClient)
    return
  const trimmedUserName = userName?.trim()
  const trimmedQuoteId = isEndOfJourney ? '' : quoteID?.trim()
  const trimmedPolicyNumber = isEndOfJourney ? '' : policyNumber?.trim()
  const trimmedPageName = pageName?.trim()

  const context = {
    kind: 'multi',
    user: {
      key: trimmedUserName,
      ...attributes,
    },
    JourneyInfo: {
      key: 'CustomerFacing',
    },
    ...(trimmedQuoteId ? { QuoteInfo: { key: trimmedQuoteId } } : {}),
    ...(trimmedPolicyNumber ? { PolicyInfo: { key: trimmedPolicyNumber } } : {}),
    ...(trimmedPageName ? { PageName: { key: trimmedPageName } } : {}),
  }
  ldClient.identify(context)
}
